import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="scroll-to-top"
export default class extends Controller {
  connect() {
    this.toggleButtonVisibility();
    window.addEventListener("scroll", () => this.toggleButtonVisibility());
  }

  disconnect() {
    window.removeEventListener("scroll", () => this.toggleButtonVisibility());
  }

  toggleButtonVisibility() {
    if (window.scrollY > 500) {
      this.element.classList.remove("opacity-0", "invisible");
      this.element.classList.add("opacity-100", "visible");
      this.element.removeAttribute("aria-hidden");
    } else {
      this.element.classList.remove("opacity-100", "visible");
      this.element.classList.add("opacity-0", "invisible");
      this.element.setAttribute("aria-hidden", "true");
    }
  }

  scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    // Move focus to the top of the page
    document.body.tabIndex = -1;
    document.body.focus();
    document.body.removeAttribute("tabIndex");
  }
}
